import { enCountriesList } from "components/stocks/modern/OperatingSegments/countries/en";
import { ptCountriesList } from "components/stocks/modern/OperatingSegments/countries/pt";
import type { IntlShape } from "react-intl";

export function genStandardizedCountries(intl: IntlShape) {
  return intl.locale.startsWith("pt") ? ptCountriesList : enCountriesList;
}
